import { styled } from '@mui/material/styles';
import { Goal } from './Goal';
import { TableCell, TableRow } from '@mui/material';

// const Text = styled('span')(({ theme }: any) => ({
//     fontWeight: '500',
//     ...theme.typography.tables.rows
// }));

const StyledTableRow = styled(TableRow)(() => ({
    height: '64px'
}));

type ColumnAlign = 'left' | 'center' | 'right' | 'inherit' | 'justify';

type ColumnDef = {
    key: string;
    align: ColumnAlign;
    width: string;
    // eslint-disable-next-line no-unused-vars
    render?: (value: any, row: any) => React.ReactNode;
};

export type SubRowProps = {
    rowData: any;
    columns: ColumnDef[];
};

export const CustomSubRow = ({ rowData, columns }: SubRowProps) => {
    // const userRole = useAppSelector((state) => state?.auth?.user?.userRole);
    return (
        <StyledTableRow>
            <TableCell sx={{ width: '48px', verticalAlign: 'middle' }}></TableCell>
            {columns.map((header) => {
                if (header.key === 'dummy') {
                    return (
                        <TableCell
                            key={header.key}
                            align={header.align}
                            sx={{
                                width: header.width,
                                verticalAlign: 'middle',
                                fontSize: '16px',
                                fontWeight: 500,
                                lineHeight: '20px'
                            }}
                        ></TableCell>
                    );
                }
                if (header.key === 'goal') {
                    return (
                        <TableCell
                            key={header.key}
                            align={header.align}
                            sx={{
                                width: header.width,
                                verticalAlign: 'middle',
                                fontSize: '16px',
                                fontWeight: 500,
                                lineHeight: '20px'
                            }}
                        >
                            <Goal type={rowData[header.key]} />
                        </TableCell>
                    );
                }
                return (
                    <TableCell
                        key={header.key}
                        align={header.align}
                        sx={{
                            width: header.width,
                            verticalAlign: 'middle',
                            fontSize: '16px',
                            fontWeight: 500,
                            lineHeight: '20px'
                        }}
                    >
                        {(header.render ? header.render(rowData[header.key], rowData) : rowData?.[header.key] || '') ||
                            ''}
                    </TableCell>
                );
            })}
        </StyledTableRow>
    );
};
// // TODO: Localization
// const formatMoney = (amount: number) =>
//     new Intl.NumberFormat('en-US', {
//         style: 'currency',
//         currency: 'USD',
//         maximumFractionDigits: 0
//     }).format(amount);
